
import { motion } from "framer-motion";
import { Heart } from "lucide-react";
import { Link } from "react-router-dom";
import ImageOverlay from "@/components/common/ImageOverlay";
import { useIsMobile } from "@/hooks/use-mobile";

export const WeddingHeroBanner = () => {
  const isMobile = useIsMobile();
  
  // Default loan parameters for the wedding loan
  const defaultLoanAmount = 15000;
  const defaultLoanTerm = 5;
  const applicationUrl = `/kilpailuta?amount=${defaultLoanAmount}&term=${defaultLoanTerm}&type=haalaina`;

  return (
    <motion.div
      initial="hidden"
      animate="visible"
      custom={1}
      variants={{
        hidden: { opacity: 0, y: 20 },
        visible: (i: number) => ({
          opacity: 1,
          y: 0,
          transition: {
            delay: i * 0.1,
            duration: 0.5,
          }
        })
      }}
      className="mb-8 md:mb-12"
    >
      <div className="relative overflow-hidden rounded-lg">
        <div className="bg-gradient-to-r from-pink-500 to-pink-600 h-auto">
          <div className="flex flex-col md:flex-row items-center">
            <div className="p-6 md:p-8 text-white md:w-1/2">
              <h2 className="text-2xl md:text-3xl font-bold mb-4 flex items-center">
                <Heart className="mr-2" /> Rahoita unelmiesi häät
              </h2>
              <p className="mb-6 text-pink-100">
                Häälaina tarjoaa joustavan rahoitusratkaisun täydellisten häidesi 
                järjestämiseen. Voit keskittyä nauttimaan erityisestä päivästäsi ilman 
                taloudellisia huolia.
              </p>
              <div className="hidden md:block">
                <Link 
                  to={applicationUrl}
                  className="bg-white text-pink-600 px-6 py-2 rounded-md font-medium hover:bg-pink-50 transition-colors inline-block"
                >
                  Kilpailuta häälaina nyt
                </Link>
              </div>
            </div>
            
            {/* Kuva näytetään aina, myös mobiilissa */}
            <div className="w-full md:w-1/2 h-48 md:h-auto relative">
              <ImageOverlay 
                imageUrl="/lovable-uploads/cb302d8d-e104-44b7-9de6-77fe6f301e21.png" 
                alt="Hääpari" 
                className="h-full w-full"
                imageClassName="h-full w-full object-cover object-center"
                onImageChange={(newUrl) => console.log("Image changed:", newUrl)}
              />
              
              {/* Mobiilissa näytettävä painike kuvan päällä */}
              {isMobile && (
                <div className="absolute bottom-4 left-0 right-0 flex justify-center">
                  <Link 
                    to={applicationUrl}
                    className="bg-white text-pink-600 px-6 py-2 rounded-md font-medium hover:bg-pink-50 transition-colors inline-block shadow-md"
                  >
                    Kilpailuta häälaina
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};
